module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "follow-the-process"
    }
  }, [_c('h1', [_vm._v("Follow the Process")]), _vm._v(" "), _c('p', [_vm._v("Be aware of, and comply with, your corporate policies and procedures. They have usually been developed over time, from lessons learnt, and reflect contemporary best practice. The policies will have been endorsed by management, so they provide protection for your actions. Following policy removes some of the emotion when dealing with issues and could protect you from allegations that you were biased. Furthermore, the need to follow established procedures is enshrined in administrative law (Procedural fairness).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8ebb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0